import ATableAccess from "./aTableAccess";

class WorkprocessAccess extends ATableAccess {

    static getAllByProjectNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "projectNumber", number);
    }

    static getAllByOrderNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "orderNumber", number);
    }

    static getAllByOrderItemNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "orderItemNumber", number);
    }

    static getAllByCostUnitNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "costUnitNumber", number);
    }

    static getAllByMachineNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "machineNumber", number);
    }

    static getAllByWorkplaceNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "workplaceNumber", number);
    }

    static getAllByWorkprocessNumber = async (db, tableName, number) => {
        return await this.getAllByNumber(db, tableName, "workprocessNumber", number);
    }

    static getAllByNumber = async (db, tableName, indexName, number) => {
        if (!db) return [];
        if (!tableName) return [];
        if (!indexName) return [];
        if (!number) return [];
        try {
            return db
                .transaction(tableName)
                .objectStore(tableName)
                .index(indexName)
                .getAll(number)
            // return await db.getFromIndex(tableName, "orderDbId", dbId);
        } catch (ex) {
            console.log(ex);
            return null;
        }
    };

}

export default WorkprocessAccess;
